import {
  IconButton,
  IDropdownOption,
  Stack,
  TooltipHost,
} from '@fluentui/react';
import {
  FormHookDropdown,
  FormHookTextField,
} from 'common/components/FormHooksFields';
import { FormHookCheckBox } from 'common/components/FormHooksFields/FormHookCheckBox';
import { ColumnData } from 'common/components/SearchBar';
import React from 'react';
import { UseFieldArrayRemove, useFormContext, useWatch } from 'react-hook-form';
import {
  CorporateWorkgroupValues,
  workgroupCurrencyOptionType,
} from 'settings/account/corporateWorkGroups/view/types';

export interface FormFieldProps {
  baseField: string;
  columnData: ColumnData;
  remove: UseFieldArrayRemove;
  index: number;
  currencyOptions: IDropdownOption<any>[];
  currencyDisabled: boolean;
}

export const FormField: React.FC<FormFieldProps> = ({
  baseField,
  columnData,
  remove,
  index,
  currencyOptions,
  currencyDisabled,
}) => {
  const watchCorporateWorkgroup = useWatch<CorporateWorkgroupValues>();
  const { setValue } = useFormContext<CorporateWorkgroupValues>();
  const isEdit = !!watchCorporateWorkgroup?.workgroupCurrencies?.[index]?.id;
  const isUpdatable =
    !isEdit ||
    watchCorporateWorkgroup?.workgroupCurrencies?.[index]?._isUpdatable;
  const isDeletable =
    !isEdit ||
    watchCorporateWorkgroup?.workgroupCurrencies?.[index]?._isDeletable;

  switch (columnData.key) {
    case 'currencyId':
      return (
        <FormHookDropdown
          name={`${baseField}.${columnData.key}`}
          options={currencyOptions}
          width={columnData.maxWidth}
          underlined
          disabled={!isUpdatable || currencyDisabled}
          onClear={() => {
            remove(index);
          }}
          onChange={(_, value) => {
            const selectedValue = value as workgroupCurrencyOptionType;
            setValue(
              `workgroupCurrencies.${index}.exchangeRate`,
              selectedValue?.exchangeRate
            );
            setValue(
              `workgroupCurrencies.${index}.spotRate`,
              selectedValue?.spotRate
            );
            setValue(
              `workgroupCurrencies.${index}.isSpotRatePreferred`,
              selectedValue?.isSpotRatePreferred
            );
          }}
        />
      );

    case 'isSpotRatePreferred':
      return (
        <Stack style={{ width: columnData.maxWidth }}>
          <FormHookCheckBox
            name={`${baseField}.${columnData.key}`}
            disabled={!isUpdatable}
          />
        </Stack>
      );

    case 'delete':
      return (
        <TooltipHost content="Delete User" id="tooltipId">
          <IconButton
            iconProps={{ iconName: 'delete' }}
            ariaLabel="Delete"
            onClick={() => {
              remove(index);
            }}
            disabled={!isDeletable}
          />
        </TooltipHost>
      );

    default:
      return (
        <FormHookTextField
          name={`${baseField}.${columnData.key}`}
          underlined
          disabled={!isUpdatable}
          style={{ width: columnData.maxWidth }}
        />
      );
  }
};
